import styled from 'styled-components';
import { theme } from 'styled-tools';

const Bold = styled.b`
  font-family: 'Untitled Sans', sans-serif;
  font-weight: 700;
  font-size: 28px;
  line-height: 40px;

  letter-spacing: -0.04em;
  color: #ffffff;

  text-align: center;
`;

const Dimmer = styled.span`
  font-family: 'Untitled Sans', sans-serif;
  font-weight: 400;
  font-size: 18px;
  line-height: 16px;
  letter-spacing: -0.02em;

  color: white;
  text-align: center;
`;

const Green = styled(Dimmer)`
  color: ${theme('colors.background.green')};
  margin-top: auto;
`;

const Red = styled(Dimmer)`
  color: ${theme('colors.background.red')};
`;

const BoldRed = styled(Bold)`
  color: ${theme('colors.background.red')};
`;

const ContainerCentre = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  row-gap: 20px;
`;

export const S = {
  Bold,
  Dimmer,
  Green,
  Red,
  BoldRed,
  ContainerCentre,
};
